import React from 'react'
import ProjectFeature from './ProjectFeature'
import projects from '../data/projects'

export default function Projects() {
  return (
    <section id="projects" aria-labelledby="projects-title" className="scroll-mt-16 py-20 md:py-32 relative">
      <div className="max-w-5xl mx-auto px-6 sm:px-8">
        <div className="flex items-center gap-4 mb-10 sm:mb-12">
          <span className="font-mono text-lime text-sm tracking-wider">03</span>
          <h2 id="projects-title" className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-display font-bold text-cream">Projects</h2>
          <div className="h-px bg-edge flex-grow" />
        </div>
        <p className="text-cream-dim text-base sm:text-lg mb-10 sm:mb-14 max-w-xl leading-relaxed font-light">
          A collection of projects I've built, ranging from web applications to
          machine learning services and hands-on infrastructure.
        </p>
        <div className="space-y-10 sm:space-y-14">
          {projects.map((project, index) => <ProjectFeature key={project.id} project={project} index={index} />)}
        </div>
      </div>
    </section>
  )
}
